import { render, staticRenderFns } from "./Beacon.vue?vue&type=template&id=5537bca5&scoped=true"
import script from "./Beacon.vue?vue&type=script&lang=js"
export * from "./Beacon.vue?vue&type=script&lang=js"
import style0 from "./Beacon.vue?vue&type=style&index=0&id=5537bca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5537bca5",
  null
  
)

export default component.exports